export default __webpack_public_path__ + "static/media/SE.f9da2d5f.svg";